import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneConsultaDocumentiComponent} from './conservazione-consulta-documenti';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('home.conservazione-consulta-documenti', {
      url: '/conservazione-consulta-documenti/:classeDocumentale/:id',
      params: {
        classeDocumentale: '',
        id: ''
      },
      ncyBreadcrumb: {
        label: 'Consulta Documenti',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Consulta Documenti'
      },
      'views': {
        'homeContent': {
          template: '<conservazione-consulta-documenti flex="100"></conservazione-consulta-documenti>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneConsultaDocumentiModule: string = ng
  .module('conservazione-consulta-documenti', [
    'ui.bootstrap',
    uiRouter,
  ])
  .component('conservazioneConsultaDocumenti', ConservazioneConsultaDocumentiComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-consulta-documenti/conservazione-consulta-documenti.module.ts